<template>
  <div class="time">
    <div class="toptime">
      <span>{{ date }}</span>
      <span>{{ day }}</span>
      <div>{{ time }}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "timeBig",
  components: {},
  data () {
    return {
      date: null,
      time: null,
      day: null
    };
  },
  created () {
    setInterval(() => {
      const date = new Date();
      let a = this.getDate(date);
      let b = date.getDay();
      this.date = a[0];
      this.time = a[1];
      this.day = this.getDay(b);
    });
  },
  mounted () { },
  methods: {
    getDate (date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date.getHours();
      h = h < 10 ? "0" + h : h;
      var minute = date.getMinutes();
      minute = minute < 10 ? "0" + minute : minute;
      var second = date.getSeconds();
      second = second < 10 ? "0" + second : second;
      return [y + "-" + m + "-" + d + " ", +h + ":" + minute + ":" + second];
    },
    getDay (day) {
      switch (day) {
        case 1:
          return "星期一";
        case 2:
          return "星期二";
        case 3:
          return "星期三";
        case 4:
          return "星期四";
        case 5:
          return "星期五";
        case 6:
          return "星期六";
        case 7:
          return "星期日";
      }
    }
  }
};
</script>

<style scoped>
.time {
  width: 200px;
  height: 100px;
  position: absolute;
  margin-right: 20px;
  right: 0;
  font-family: 'DIN Alternate';
}
.toptime {
  width: 100%;
  height: 100%;
  color: #9bb1df;
  margin-top: 10px;
  padding-right: 100px;
  font-size: 20px;
}
.toptime span {
  display: inline-block;
  line-height: 50px;
}
.toptime div {
  height: 40px;
  padding-left: 22%;
  font-size: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/toptime.vue